<template>
  <div class="page-wrapper">
    <common :goodsData="goodsData" :modify="true" :disabled="true" ></common>
  </div>
</template>
 
<script type="text/ecmascript-6">
import {readGoodsArchives} from 'api/archives'
import Common from './../components/Common'

export default {
  name:'addgoods',
  components:{
    Common
  },
  created(){
    if(this.goodsCode){
      readGoodsArchives({goodsArchivesCode: this.goodsCode}).then( res => {
        this.goodsData = res.data
      })
    }
  },
  computed:{
    goodsCode() {
      return this.$store.state.goodsArchives.readCode;
    }
  },
  data () {
    return {
      goodsData:null
    };
 }
}
</script>
 
<style lang="css" scoped>
 .go-enter-active,.go-leave-active{
    transition:all .2s linear;
}
.go-enter,.go-leave-to{
    transform: translate3d(200px,0,0)
}
</style>